import { Box } from '@material-ui/core'
import ImageIcon from '@material-ui/icons/Image'
import { useState } from 'react'

import { FlexBox } from '../../../components/Base/FlexBox'
import { formatDate } from '../../../helpers/formatters'
import { useBreakpoint } from '../../../hooks/useBreakpoint'
import { User } from '../../../models/user'
import { ProfileCard, ProfileCardItem } from './ProfileCard'
import { ProfileCDLPreview } from './ProfileCDLPreview'

interface ProfileCDLProps {
  user: User
  canEdit: boolean
}

export function ProfileCDL({ user, canEdit }: ProfileCDLProps) {
  const [CDLForModal, setCDLForModal] = useState({ url: '', isFront: false })
  const haveUploadedCDL = Boolean(user.driver?.licenseFront && user.driver?.licenseBack)
  const mobileXS = useBreakpoint('xs')

  const handleOpenPreviewCDL = (isFront: boolean) => {
    const url = isFront ? user.driver.licenseFront : user.driver.licenseBack
    if (!url) return

    const [baseUrl] = url.split('?')
    const isPdf = baseUrl.endsWith('.pdf')

    if (isPdf) return window.open(url, '_blank')
    setCDLForModal({ url, isFront })
  }

  function renderCdl(isFront = false) {
    if (!canEdit) return null

    return (
      <FlexBox alignItems="center" gap="5px" onClick={() => handleOpenPreviewCDL(isFront)}>
        <ImageIcon fontSize={mobileXS ? 'small' : undefined} />
        <span style={{ marginTop: '3px' }}>{isFront ? 'Front' : 'Back'}</span>
      </FlexBox>
    )
  }

  return (
    <>
      <ProfileCard title="Commercial Driver’s license">
        <ProfileCardItem label="CDL">{user.driver?.licenseNumber || '-'}</ProfileCardItem>
        <ProfileCardItem label="State">{user.driver?.licenseState || '-'}</ProfileCardItem>
        <ProfileCardItem label="Expiration Date">
          {user.driver?.licenseExpiration ? formatDate(user.driver?.licenseExpiration) : '-'}
        </ProfileCardItem>
        {haveUploadedCDL && (
          <>
            <ProfileCardItem label="Uploaded CDL">
              {renderCdl(true)}
              <Box mt={0.5} />
              {renderCdl(false)}
            </ProfileCardItem>
          </>
        )}
      </ProfileCard>

      {CDLForModal.url && (
        <ProfileCDLPreview
          handleClose={() => setCDLForModal({ url: '', isFront: false })}
          imgUrl={CDLForModal.url}
          isFront={CDLForModal.isFront}
        />
      )}
    </>
  )
}
